import { Routes } from '@angular/router';
import { isPersonalisedExposeGuard } from './guards/is-personalisedExpose.guard';

export const routes: Routes = [
  {
    path: 'cancellation',
    loadComponent: async () =>
      import(
        './pages/brokerage-contract-cancellation/brokerage-contract-cancellation.component'
      ).then((l) => l.AppBrokerageContractCancellationComponent),
  },
  {
    path: ':exposeUrlSlug',
    canMatch: [isPersonalisedExposeGuard()],
    loadComponent: async () =>
      import('./pages/brokerage-agreement/brokerage-agreement.component').then(
        (l) => l.BrokerageAgreementComponent,
      ),
  },
  {
    path: ':exposeUrlSlug',
    loadComponent: async () =>
      import('./pages/expose/expose.component').then((l) => l.ExposeComponent),
  },
];
